import { useQueryParamsHook } from '@/hooks/useQueryParamsHook';

/**
 * 마이 페이지 탭 (가로 스크롤, 밑줄 표시)
 */
export function FdTab({
    TAB_LIST
}) {
    const queryParamsHook = useQueryParamsHook();
    const tabType = queryParamsHook.params?.tabType;
    const knownTab = TAB_LIST?.some(tab => tab.type === tabType);

    const handleChangeRoute = (tabType) => {
        queryParamsHook.setSearchParams({ ...queryParamsHook?.params, tabType: tabType }, { replace: true });
    }

    return (
        <nav aria-label="마이 페이지 메뉴" className="-mx-3 overflow-x-auto px-3 [scrollbar-width:none] sm:mx-0 sm:px-0 [&::-webkit-scrollbar]:hidden">
            <div role="tablist" className="flex w-max min-w-full gap-1 border-b border-black/[0.08]">
                {TAB_LIST?.map(tab => {
                    const active = tabType === tab.type || (tab.default && (!tabType || !knownTab));
                    return (
                        <button
                            key={tab.type}
                            type='button'
                            role="tab"
                            aria-selected={active}
                            onClick={() => handleChangeRoute(tab.type)}
                            className={`relative whitespace-nowrap px-3 pb-3 pt-2 text-[15px] font-semibold transition ${active ? 'text-gray-900' : 'text-gray-400 hover:text-gray-700'}`}
                        >
                            {tab.name}
                            {active && <span className="absolute inset-x-2 -bottom-px h-[2.5px] rounded-full bg-gray-900" />}
                        </button>
                    );
                })}
            </div>
        </nav>
    );
}
